import React from 'react';
interface ContactFormProps {
  title: string;
  id?: string;
}
export function ContactForm({
  title,
  id
}: ContactFormProps) {
  return <div id={id} className="w-full max-w-lg mx-auto" style={{
    overflow: 'visible',
    height: 'auto'
  }} data-id="element-33">
      <iframe title={title} allowTransparency={true} allow="geolocation; microphone; camera; fullscreen; payment" src="https://form.jotform.com/261045684071051?background=1" frameBorder="0" style={{
      width: '100%',
      height: '790px',
      border: 'none',
      background: 'transparent'
    }} scrolling="no" data-id="element-34" />
    </div>;
}